import * as React from 'react';

import styled from '@emotion/styled';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { COLORS } from '@root/colors';

const Warning = styled.strong`
  color: ${COLORS.red};
`;

export const TeachInWarning: React.FC = () => (
  <Warning>
    <FontAwesomeIcon icon={faExclamationTriangle} /> Requires teach-in
  </Warning>
);
